import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

export const filterStockExchangeSchema = z.object({
  code_contains: z.string().nullable().optional(),
  country_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
});

export type FilterStockExchangeSchema = z.infer<
  typeof filterStockExchangeSchema
>;

export const fields: Field[] = [
  {
    name: "code_contains",
    label: "Code",
    type: "input",
  },
  {
    name: "country_contains",
    label: "Country",
    type: "asyncAutocomplete",
    base_url: "instit-quantilia/countries",
    column_name: "en_translation",
    id_column: "id",
  },
];

export const client = "qtl - referential";

export function FilterStockExchange() {
  return (
    <FilterTable
      client={client}
      schema={filterStockExchangeSchema}
      tableName="stock_exchanges"
      customBuildPath={() => `${client}/stock_exchanges`}
      fields={fields}
    />
  );
}
